import { usePromptToolboxContext } from "@Context/prompt-toolbox/PromptToolboxContext";
import { useUtilityContext } from "@Context/prompt-toolbox/UtilityContext";

const DeleteVersion = () => {
  const { setModal } = useUtilityContext();
  const { selectedPromptVersion, deleteVersion } = usePromptToolboxContext();

  const handleDeleteVersion = async () => {
    setModal("deleteVersion", false);
    await deleteVersion();
  };

  return (
    <div>
      <span className="flex flex-col gap-y-10">
        <label>
          This will delete {selectedPromptVersion?.name} version{" "}
          {selectedPromptVersion?.version.version}
        </label>
        <span className="flex flex-row items-center justify-end gap-x-2">
          <button data-testid="delete-version-modal-button"
            onClick={handleDeleteVersion}
            className="rounded-md bg-brandRed-300 px-4 py-2 text-white"
          >
            Delete
          </button>
          <button data-testid="delete-version-modal-cancel-button"
            onClick={() => setModal("deleteVersion", false)}
            className="rounded-md border border-gray-400 bg-white px-4 py-2"
          >
            Cancel
          </button>
        </span>
      </span>
    </div>
  );
};

export default DeleteVersion;
